import React from 'react';
import Drawer from '@mui/material/Drawer';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/system';

const Scrollbar = React.lazy(() => import('components/Scrollbar'));

const IconButtonWrapper = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: 15,
  right: 15,
  '& svg': {
    color: theme.palette.primary.main,
    width: 30,
    height: 30
  }
}));

const ScrollbarWrapper = styled('div')({
  height: '100%',
  overflowY: 'auto',
  marginTop: 40
});

const DrawerComponent = ({ children, anchor, open, onClose }) => {
  return (
    <Drawer anchor={anchor} open={open} onClose={onClose}>
      <IconButtonWrapper onClick={onClose} aria-label="close drawer">
        <CloseIcon />
      </IconButtonWrapper>
      <ScrollbarWrapper>
        <Scrollbar>{children}</Scrollbar>
      </ScrollbarWrapper>
    </Drawer>
  );
};

export default DrawerComponent;
